<template>
  <mds-section
    :border="linkGoalInfo.goalborder"
    :title="linkGoalInfo.goalTitle"
    bold
  >
    <template #mds-section-actions>
      <mds-button
        variation="icon-only"
        iconRight="caret-circle-down"
        type="button"
      ></mds-button>
    </template>

    <mds-button
      @click="openPopup"
      id="linkGoalButton"
      icon="plus"
      size="medium"
      >{{ linkGoalInfo.goalsectionName }}</mds-button
    >
    <mds-popover
      width="200px"
      triggered-by="linkGoalButton"
      v-model="linkToggle"
      :position="['top-right']"
    >
      <p>Not for user.</p>
    </mds-popover>
  </mds-section>
</template>
<script>
import MdsSection from "@mds/section";
import { MdsButton } from "@mds/button";
import MdsPopover from "@mds/popover";
export default {
  props: {
    linkGoalInfo: {
      type: Object,
    },
  },
  components: {
    MdsSection,
    MdsButton,
    MdsPopover,
  },
  data() {
    return {
      linkToggle: false,
    };
  },
  methods: {
    openPopup() {
      this.linkToggle = !this.linkToggle;
    },
  },
};
</script>
<style lang="scss" scoped></style>
